import { format } from 'date-fns';
import { nl, fr, enGB } from 'date-fns/locale';

export const LANGUAGE_MAPPER: { [key: string]: Locale } = { en: enGB, nl: nl, fr: fr };

export const dateFormatForReq = (date: string | undefined | Date) => {
  if (date) {
    return format(new Date(date), 'yyyy-MM-dd');
  }
};

export const dateFormatFromRequest = (date: string | undefined | Date) => {
  if (date) {
    return format(new Date(date), 'dd / MM / yyyy');
  }
};
